import axiosInstance from "../config/axios.config";

const RESOURCE_PATHS = {
  vendors: "vendors",
  companies: "companies",
  categories: "categories",
  salts: "salts",
  "product-types": "product-types",
  "item-types": "item-types",
  "hsn-and-sac": "hsn-and-sac",
};

export const getPharmacyConfigListApi = (resource, params) => {
  return axiosInstance.get(
    `pharmacy/configs/${RESOURCE_PATHS[resource]}/?${params}`
  );
};

export const addPharmacyConfigApi = (resource, payload) => {
  return axiosInstance.post(
    `pharmacy/configs/${RESOURCE_PATHS[resource]}/`,
    payload
  );
};

export const updatePharmacyConfigApi = (resource, id, payload) => {
  return axiosInstance.patch(
    `pharmacy/configs/${RESOURCE_PATHS[resource]}/${id}/`,
    payload
  );
};

export const deletePharmacyConfigApi = (resource, id) => {
  return axiosInstance.delete(
    `pharmacy/configs/${RESOURCE_PATHS[resource]}/${id}/`
  );
};
